/* eslint-disable react/prop-types */
import React from 'react';

import styled from 'react-emotion';
import { Container as SemanticContainer } from 'semantic-ui-react';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';

import {
  ProductDetailsVerticalSeparator,
  GridArea,
  ProductDetailsHorizontalSeparator,
} from '~/modules/coreUI/components/layouts/helpers/GridLayout';

const DesktopGrid = styled.div`
  display: grid;
  grid-template:
    'slider   header         vRule1         price          .                 actionButtons' max-content
    'slider   rootVariants   vRule1         vendorDetails  vendorDetails     vendorDetails' minmax(0, max-content)
    'slider   rootVariants   .              .              .                 shareButtons' 1fr
    'hRule    hRule          hRule          hRule          hRule             hRule' auto
    'tabs     tabs           tabs           tabs           tabs              tabs' auto
    'reviews  reviews        reviews        reviews        reviews           reviews' auto
    / 392px 12fr 30px auto 25px auto;

  grid-column-gap: ${props => 2.5 * props.theme.new.spacer}px;
  grid-row-gap: ${props => props.theme.paddings.normal}px;

  padding-top: ${props => 1.5 * props.theme.new.spacer}px;
`;

const ProductDetailsDesktopLayout = props => (
  <React.Fragment>
    {props.loader}
    <SemanticContainer style={{ display: props.loader && 'none' }}>
      <DesktopGrid>
        <GridArea gridArea="header" leftAligned>
          {props.productTitle}
        </GridArea>
        <GridArea gridArea="vRule1">
          <ProductDetailsVerticalSeparator />
        </GridArea>
        <GridArea gridArea="price">{props.productPrice}</GridArea>
        <GridArea gridArea="slider">{props.productImageSlider}</GridArea>
        <GridArea gridArea="vendorDetails">
          {props.vendorDetails}
          {props.cartActions}
          {props.BuyingOptionsLink}
          {props.SellingOptionLink}
        </GridArea>
        <GridArea gridArea="rootVariants" paddingTop={1.5} leftAligned topJustified>
          {props.options}
          {props.offeredVariants}
          {props.packageVariants}
          {props.packageVariants ? <Spacer size={2.5} /> : null}
          {props.productOffers}
          {props.productSummary}
        </GridArea>
        <GridArea gridArea="actionButtons" rightAligned topJustified>
          {props.actionButtons}
        </GridArea>
        <GridArea gridArea="shareButtons" rightAligned bottomJustified>
          {props.shareButtons}
        </GridArea>
        <GridArea gridArea="hRule" stretchAligned>
          <ProductDetailsHorizontalSeparator />
        </GridArea>
        <GridArea gridArea="tabs" stretchAligned>
          {props.productTabs}
          {props.OfferDescription}
        </GridArea>
        <GridArea gridArea="reviews" stretchAligned>
          <Separator customColorTone="#f9f9f9" separatorLength="full" separatorWeight={1.5} spacerSize={[1.5, 1.5, 2.5]} />
          {props.productReviews}
        </GridArea>
      </DesktopGrid>
      {props.relatedProducts}
      <Spacer size={4} />
    </SemanticContainer>
  </React.Fragment>
);

export default withMedia(ProductDetailsDesktopLayout);
